import {createSelector} from 'reselect';

import {defaultIsTeammateWorkspaceExpanded} from '../../../components/inboxes/workspaces/teammateWorkspace/constants';
import {CollapsedItemKeyPrefixesEnum} from '../../../models/api/localPreferencesModel';
import {getFindIsExpanded} from '../localPreferences/localPreferencesSelectors';
import {getUserNamespace} from '../teammates/teammatesSelectors';

/*
 * Constants.
 */

export const lensesWorkspaceExpandedKey = `${CollapsedItemKeyPrefixesEnum.WORKSPACE}lenses`;
export const defaultIsLensesWorkspaceExpanded = true;

/*
 * Selectors.
 */

/** Find the expanded state for user's personal workspace. */
export function makeGetIsTeammateWorkspaceExpanded() {
  return createSelector([getUserNamespace, getFindIsExpanded], (userNamespace, findIsExpanded) =>
    findIsExpanded(buildTeammateWorkspaceExpandedKey(userNamespace), defaultIsTeammateWorkspaceExpanded),
  );
}

/** Find the expanded state for user's personal workspace. */
export function makeGetIsLensesWorkspaceExpanded() {
  return createSelector([getUserNamespace, getFindIsExpanded], (userNamespace, findIsExpanded) =>
    findIsExpanded(lensesWorkspaceExpandedKey, defaultIsTeammateWorkspaceExpanded),
  );
}

/*
 * Helpers.
 */

export function buildTeammateWorkspaceExpandedKey(userNamespace: string) {
  return `${CollapsedItemKeyPrefixesEnum.WORKSPACE}${userNamespace}`;
}
